export default __webpack_public_path__ + "static/media/promo_04.e578733c.jpg";